
export const AMEACA = 'Ameaça';

export const OPORTUNIDADE = 'Oportunidade';

export const AMEACA_NORMALIZADO = 'ameaca';
export const OPORTUNIDADE_NORMALIZADO = 'oportunidade';

export const CLASSIFICACOES_AMBIENTE_EXTERNO = [
    AMEACA,
    OPORTUNIDADE
];
